(function() {
  function esc(value) {
    return String(value || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function track(eventName, data) {
    if (eventName === 'video_impression' || eventName === 'shop_grid_impression') {
      data = data || {};
      var impressionKey = eventName + '|' + (data.placement || window.location.pathname || 'page');
      window.__socialBroMediaImpressions = window.__socialBroMediaImpressions || {};
      if (window.__socialBroMediaImpressions[impressionKey]) return;
      window.__socialBroMediaImpressions[impressionKey] = true;
    }
    var payload = Object.assign({ event: eventName }, data || {});
    if (window.dataLayer && Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    rememberSocialBroAssist(eventName, data);
  }
  function rememberSocialBroAssist(eventName, data) {
    if (['video_play', 'video_click_product', 'video_complete', 'shop_grid_open', 'shop_grid_click_product'].indexOf(eventName) === -1) return;
    data = data || {};
    var assist = {
      source: eventName.indexOf('shop_grid') === 0 ? 'shop_grid' : 'video_layer',
      event: eventName,
      product_id: String(data.product_id || '').slice(0, 64),
      asset_id: String(data.video_url || data.carousel_id || '').slice(0, 500),
      placement: String(data.placement || '').slice(0, 128),
      title: String(data.video_title || data.product_title || '').slice(0, 255),
      ts: String(Date.now())
    };
    if (!assist.product_id && !assist.asset_id) return;
    try {
      var raw = JSON.stringify(assist);
      window.sessionStorage && window.sessionStorage.setItem('osh_socialbro_assist', raw);
      document.cookie = 'osh_socialbro_assist=' + encodeURIComponent(raw) + '; path=/; max-age=1209600; SameSite=Lax';
    } catch (e) {}
  }
  function trackAndNavigate(event, eventName, data, url) {
    var href = url || (event && event.currentTarget && event.currentTarget.href) || '';
    if (!href || href === '#' || (event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1))) {
      track(eventName, data);
      return;
    }
    if (event) event.preventDefault();
    var done = false;
    var go = function() {
      if (done) return;
      done = true;
      window.location.href = href;
    };
    var payload = Object.assign({ event: eventName, event_callback: go, event_timeout: 700 }, data || {});
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
      window.setTimeout(go, 750);
    } else {
      go();
    }
  }
  function priceHtml(item) {
    if (!item.price_text && !item.compare_at_price_text) return '';
    return '<div class="shop-grid-card__price">' + (item.compare_at_price_text ? '<span class="shop-grid-card__compare">' + esc(item.compare_at_price_text) + '</span>' : '') + (item.price_text ? '<span>' + esc(item.price_text) + '</span>' : '') + '</div>';
  }
  function modalPriceHtml(item) {
    if (!item.price_text && !item.compare_at_price_text) return '';
    return (item.compare_at_price_text ? '<span class="shop-grid-homepage-modal__compare">' + esc(item.compare_at_price_text) + '</span>' : '') + (item.price_text ? '<span>' + esc(item.price_text) + '</span>' : '');
  }
  function overlayText(item) {
    var first = item.slides && item.slides[0] ? item.slides[0].overlay_text : '';
    return first || 'Tap to shop';
  }
  function render(root, item, openModal) {
    var card = document.createElement('article');
    card.className = 'shop-grid-card';
    card.innerHTML =
      '<button class="shop-grid-card__cover" type="button" aria-label="Open style carousel">' +
        '<img loading="lazy" src="' + esc(item.cover_image_url) + '" alt="' + esc(item.product_title || 'Product carousel') + '">' +
        '<span class="shop-grid-card__badge">' + esc(overlayText(item)) + '</span>' +
      '</button>' +
      '<div class="shop-grid-card__meta">' +
        (item.product_image_url ? '<img class="shop-grid-card__thumb" loading="lazy" src="' + esc(item.product_image_url) + '" alt="">' : '<span></span>') +
        '<div><a class="shop-grid-card__title" title="' + esc(item.product_title || 'Shop product') + '" href="' + esc(item.product_url) + '">' + esc(item.product_title || 'Shop product') + '</a>' + priceHtml(item) + '</div>' +
      '</div>';
    card.querySelector('.shop-grid-card__cover').addEventListener('click', function() {
      openModal(item, 0);
    });
    card.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function(event) {
        trackAndNavigate(event, 'shop_grid_click_product', { placement: 'homepage_shop_grid', product_id: item.product_id || '', carousel_id: item.id || '', product_title: item.product_title || '' });
      });
    });
    track('shop_grid_impression', { placement: 'homepage_shop_grid', product_id: item.product_id || '', carousel_id: item.id || '', product_title: item.product_title || '' });
    return card;
  }
  document.querySelectorAll('[data-shop-grid-homepage]').forEach(function(root) {
    if (root.dataset.loaded === '1') return;
    root.dataset.loaded = '1';
    root.setAttribute('aria-busy', 'true');
    var trackEl = root.querySelector('[data-shop-grid-track]');
    var loadingMarkup = trackEl.innerHTML;
    var modal = root.querySelector('[data-shop-grid-homepage-modal]');
    var modalImage = root.querySelector('[data-shop-grid-homepage-image]');
    var modalTitle = root.querySelector('[data-shop-grid-homepage-title]');
    var modalCaption = root.querySelector('[data-shop-grid-homepage-caption]');
    var modalPrice = root.querySelector('[data-shop-grid-homepage-price]');
    var modalLink = root.querySelector('[data-shop-grid-homepage-product-link]');
    var active = { item: null, index: 0 };
    function openModal(item, index) {
      active.item = item;
      active.index = index || 0;
      renderModal();
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      track('shop_grid_open', { placement: 'homepage_shop_grid', product_id: item.product_id || '', carousel_id: item.id || '', product_title: item.product_title || '' });
    }
    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }
    function prevSlide() {
      active.index--;
      renderModal();
    }
    function nextSlide() {
      active.index++;
      renderModal();
    }
    function renderModal() {
      var item = active.item;
      var slides = item && item.slides ? item.slides : [];
      if (!slides.length) return;
      if (active.index < 0) active.index = slides.length - 1;
      if (active.index >= slides.length) active.index = 0;
      var slide = slides[active.index];
      modalImage.src = slide.image_url;
      modalImage.alt = item.product_title || 'Product carousel slide';
      modalTitle.textContent = item.product_title || 'Shop product';
      modalCaption.textContent = (item.caption || '') + (item.hashtags ? '\n\n' + item.hashtags : '');
      modalPrice.innerHTML = modalPriceHtml(item);
      modalLink.href = item.product_url || '#';
      modalLink.textContent = 'Shop ' + (item.product_title || 'product');
      track('shop_grid_slide_view', { placement: 'homepage_shop_grid', product_id: item.product_id || '', carousel_id: item.id || '', slide: active.index + 1 });
    }
    root.querySelector('[data-shop-grid-homepage-prev]').addEventListener('click', prevSlide);
    root.querySelector('[data-shop-grid-homepage-next]').addEventListener('click', nextSlide);
    root.querySelectorAll('[data-shop-grid-homepage-close]').forEach(function(el) { el.addEventListener('click', closeModal); });
    var touch = { startX: 0, startY: 0, lastX: 0, lastY: 0, active: false };
    modal.addEventListener('touchstart', function(event) {
      if (event.target.closest('.shop-grid-homepage-modal__info')) return;
      if (!event.touches || event.touches.length !== 1) return;
      touch.active = true;
      touch.startX = event.touches[0].clientX;
      touch.startY = event.touches[0].clientY;
      touch.lastX = touch.startX;
      touch.lastY = touch.startY;
    }, { passive: true });
    modal.addEventListener('touchmove', function(event) {
      if (!touch.active || !event.touches || event.touches.length !== 1) return;
      touch.lastX = event.touches[0].clientX;
      touch.lastY = event.touches[0].clientY;
    }, { passive: true });
    modal.addEventListener('touchend', function() {
      if (!touch.active) return;
      touch.active = false;
      var dx = touch.lastX - touch.startX;
      var dy = touch.lastY - touch.startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy) * 1.25) return;
      if (dx < 0) nextSlide();
      else prevSlide();
    });
    modalLink.addEventListener('click', function(event) {
      if (!active.item) return;
      trackAndNavigate(event, 'shop_grid_click_product', { placement: 'homepage_shop_grid_modal', product_id: active.item.product_id || '', carousel_id: active.item.id || '', product_title: active.item.product_title || '' });
    });
    document.addEventListener('keydown', function(event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') closeModal();
      if (event.key === 'ArrowLeft') prevSlide();
      if (event.key === 'ArrowRight') nextSlide();
    });
    fetch(root.dataset.apiUrl, { credentials: 'omit' }).then(function(res) { return res.json(); }).then(function(json) {
      if (!json.ok || !json.carousels || !json.carousels.length) throw new Error('No style galleries available');
      // Replace skeletons once; intermediate grids can trigger scroll re-snapping.
      var cards = document.createDocumentFragment();
      json.carousels.forEach(function(item) { cards.appendChild(render(root, item, openModal)); });
      trackEl.replaceChildren(cards);
      root.classList.remove('is-loading', 'is-unavailable');
      root.setAttribute('aria-busy', 'false');
      root.hidden = false;
    }).catch(function() {
      root.classList.remove('is-loading');
      root.classList.add('is-unavailable');
      root.setAttribute('aria-busy', 'false');
      // Retain responsive sizing boxes, but replace their visuals with a useful link.
      trackEl.innerHTML = loadingMarkup + '<p class="shop-grid-homepage__fallback" role="status">Explore our <a href="/style/">Style Gallery</a>.</p>';
      trackEl.scrollLeft = 0;
    });
  });
})();
